.InputSearch {
  border-radius: 30px;
  background: var(--colori-neutri-white);
  box-shadow: 1px 2px 0px 0px rgba(17, 138, 178, 0.23);

  border: 1px solid transparent;
  display: flex;
  padding: 8px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  width: 100%;
  padding-left: 48px;
  padding-right: 100px;
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: var(--secondary);
}

.InputContainer {
  position: relative;
  width: 100%;
}

.SearchIcon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.ButtonFiltersActive {
  display: flex;
  width: 32px;
  height: 32px;
  padding: 5px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 10px;
  border: 1px solid var(--primary);
  background: var(--primary);
  cursor: pointer;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
}

.ButtonFilters {
  display: flex;
  width: 32px;
  height: 32px;
  padding: 5px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 10px;
  border: 1px solid var(--primary);
  background: var(--primary);
  cursor: pointer;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
}

.ButtonOrdering {
  display: flex;
  width: 32px;
  height: 32px;
  padding: 5px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  position: absolute;
  cursor: pointer;
  right: 48px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 10px;
  border: 1px solid var(--secondary);
  background: var(--secondary);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
}

.InputSearch:focus-visible {
  border-radius: 30px;
  border: 1px solid var(--secondary-variant);
  background: var(--colori-neutri-white);
  box-shadow: 1px 2px 0px 0px rgba(17, 138, 178, 0.23);
  outline: none;
}

.ContainerList {
  padding: 16px;
  width: 100%;
  height: calc(100% - var(--topbar-mobile-height));
}

.MonumentCard {
  display: flex;
  min-height: 84px;
  padding: 16px 24px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  align-self: stretch;
  border-radius: 5px;
  background: var(--colori-neutri-white);
  margin-bottom: 4px;
}

.ListMonuments {
  border-radius: 10px;
  background: var(--overlay);
  margin-top: 8px;
  padding: 8px;
  height: 100%;
  overflow-y: auto;
  position: relative;
}

.MonumentTitle {
  color: var(--primary);
  overflow: hidden;
  text-overflow: ellipsis;
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  max-width: 200px;
}

.City {
  color: var(--colori-neutri-gray);
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.NumberPhoto {
  color: var(--primary);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: flex;
  align-items: center;
}

.Distance {
  color: var(--colori-neutri-gray);
  text-align: center;
  font-family: var(--font-roboto-slab);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 4px;
}

.Badge{
  position: absolute;
  top: -3px;
  right: -2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--tertiary);
}

.NessunRisultato {
  color: var(--primary);
  text-align: center;
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}